import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const ErrorMessage = () => {
  const { t } = useTranslation('common');
  return <Box>{t('error')}</Box>;
};
